import 'babel-polyfill/dist/polyfill';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import StateHOF, { setAccessToken } from './StateHOF';
import CreateOrReadOne from './AppLib/CreateOrReadOne';
import ReadMany from './AppLib/ReadMany';
import Update from './AppLib/Update';
import IndexRoute from './AppLib/IndexRoute';
import NavBar from './AppLib/NavBar';
import CodeLogin from './AppLib/LoginLib/CodeLogin';
import EmailPasswordLogin from './AppLib/LoginLib/EmailPasswordLogin';
import ForgotPassword from './AppLib/LoginLib/ForgotPassword';
import withOptionItems from './AppLib/formLib/withOptionItems';
import Label from './AppLib/formLib/Label';
import Footer from './AppLib/Footer';

class App extends Component {
  componentDidMount() {
    document.title = this.props.config.title || 'CMS';
  }
  render() {
    const { config } = this.props;
    const resourceRouteElements = config.resources.reduce((acc, resource) => {
      const { uniqKey } = resource;
      const { create, readMany, readOne, update } = resource.crudMapping;

      const resourceName = resource.displayName || resource.name;

      if (readMany) {
        const path = `/${resource.name.startsWith('template') ? resource.name : resourceName}`;
        acc.push(
          <Route
            key={path}
            exact
            path={path}
            render={props => <ReadMany resource={resource} config={config} {...props} />}
          />,
        );
      }
      if (create || readOne) {
        const path = `/${resource.name.startsWith('template') ? resource.name : resourceName}/:${uniqKey}`;
        acc.push(
          <Route
            key={path}
            exact
            path={path}
            render={props => <CreateOrReadOne resource={resource} config={config} {...props} />}
          />,
        );
      }
      if (update) {
        const path = `/${resourceName}/:${uniqKey}/edit`;
        acc.push(
          <Route
            key={path}
            exact
            path={path}
            render={props => <Update resource={resource} config={config} {...props} />}
          />,
        );
      }
      return acc;
    }, []);

    return (
      <div>
        <BrowserRouter>
          <div className="app-container">
            <NavBar config={config} />
            <div className="container-fluid">
              <Route render={props => <IndexRoute {...props} config={config} />} />
              {resourceRouteElements}
            </div>
            <Footer />
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

function DefaultLogin() {
  return (
    <div>
      <h1>You need to provide a React Component to the Login option</h1>
    </div>
  );
}

function AppWithGuard(props) {
  const { config } = props;
  const Login = config.Login || DefaultLogin;

  const ComponentWithGuard = (prop) => {
    if (prop.accessToken) {
      return <App {...prop} />;
    }
    return Login ? <Login {...prop} /> : null;
  };

  const ComponentWithState = connect(
    state => ({ accessToken: state.accessToken }),
    { setAccessToken },
  )(ComponentWithGuard);

  return <ComponentWithState {...props} />;
}

function AppWithToast(props) {
  return (
    <div>
      <ToastContainer
        position="top-center"
        type="default"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
      />
      <AppWithGuard {...props} />
    </div>
  );
}

export default StateHOF(AppWithToast);
export {
  CodeLogin,
  EmailPasswordLogin,
  ForgotPassword,
  withOptionItems,
  Label,
  setAccessToken,
  StateHOF,
  ToastContainer,
  toast,
};



// WEBPACK FOOTER //
// ./src/byob-cms/src/App.js